module.exports = __webpack_public_path__ + "static/media/295518.1c715d22.png";